import { useTranslation } from "react-i18next"
import { Step } from "react-joyride"
import { CustomBodyText, CustomHeader } from "../manualComponets"

export const downloadDataSteps = (
	translationFunc?: ReturnType<typeof useTranslation>["t"]
): Step[] => {
	const t = translationFunc ?? ((text: string) => text)
	return [
		{
			target: "#header-user-manual",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("downloadData.pageHeader.header")}</CustomHeader>
					<CustomBodyText>{t("downloadData.pageHeader.content")}</CustomBodyText>
				</div>
			),
			placement: "left-start",
			disableBeacon: true,
		},
		{
			target: "#op-mode-select",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("downloadData.opModeSelect.header")}</CustomHeader>
					<CustomBodyText>{t("downloadData.opModeSelect.content")}</CustomBodyText>
				</div>
			),
			placement: "right",
			disableScrolling: true,
		},
		{
			target: "#time-select",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("downloadData.timeSelect.header")}</CustomHeader>
					<CustomBodyText>{t("downloadData.timeSelect.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
			disableScrolling: true,
		},
		{
			target: "#sensors-select",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("downloadData.sensorsSelect.header")}</CustomHeader>
					<CustomBodyText>{t("downloadData.sensorsSelect.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
			disableScrolling: true,
		},
		{
			target: "#search-button",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("downloadData.searchButton.header")}</CustomHeader>
					<CustomBodyText>{t("downloadData.searchButton.content")}</CustomBodyText>
				</div>
			),
			placement: "left",
			disableScrolling: true,
		},
		{
			target: "#download-button",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("downloadData.downloadButton.header")}</CustomHeader>
					<CustomBodyText>{t("downloadData.downloadButton.content")}</CustomBodyText>
				</div>
			),
			placement: "left",
			disableScrolling: true,
		},
	]
}
